import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

const firebaseConfig = {
  apiKey: 'AIzaSyDQcZSmcG6obXfl8RlrEV2HKEPTL9Qq2u0',
  authDomain: 'acorn-application-dashboard.firebaseapp.com',
  databaseURL: 'https://acorn-application-dashboard.firebaseio.com',
  projectId: 'acorn-application-dashboard',
  storageBucket: 'acorn-application-dashboard.appspot.com',
  messagingSenderId: '261781331125',
  appId: '1:261781331125:web:f48d67d74d44ce63c272fc',
}

const fb = firebase.initializeApp(firebaseConfig)

// Get a Firestore instance
const db = fb.firestore()
const auth = fb.auth()

export { fb, db, auth }
